import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import Table from "../reports/reportlist/LeaseListingTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TopHeader from "../layout/TopHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import {
  faPen,
  faPlus,
  faSave,
  faTimes,
  faUndo,
  faFileExcel,
  faEye,
  faUpload,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
//import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { ViewLeasePdfReader } from "../utils/ViewLeaseDocumentViewer";
import { PopupMessage } from "../utils/utils";
//import { fileUploadPath } from "../../utils/index";
import Popup from "reactjs-popup";

import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import RevenueTable from "../reports/reportlist/RevenueTable";

import * as Yup from "yup";
import { getUserType, fileUploadPath } from "../utils/index";
var ReactS3Uploader = require("react-s3-uploader");

if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),    
    leaseId: Yup.number().required("Required").transform((value) => (isNaN(value) ? undefined : value)).nullable()

  });

} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    leaseId: Yup.number().required("Required").transform((value) => (isNaN(value) ? undefined : value)).nullable()

  });

} else {
  var reportFilterForm = Yup.object().shape({
    leaseId: Yup.number().required("Required").transform((value) => (isNaN(value) ? undefined : value)).nullable(),
    financialYearOne: Yup.string().required("Required"),
    chargeType: Yup.string().required("Required"),
  });
}

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;
//const [selectedValue, setSelectedValue] = useState([]);

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

let financialYear = [];
// var i = 0;  let currentYear = new Date().getFullYear();
// financialYear.push({ id: (currentYear + 1) , value: (currentYear )  + "-" + (currentYear + 1) })
// for (; i <= 10; i++) {
//   financialYear.push({ id: currentYear , value: (currentYear - 1)  + "-" + currentYear });
//   --currentYear;
// }

var tableCounter = 0;

const headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + localStorage.getItem('TOKEN') };

class InvoiceValidation extends React.Component {
  groupId = { value: "" };
  state = {
    totalInvoiceAmount: 0,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: '',
    brandSelected: [],
    selectedValue: [],
    setSelectedValue: [],
    leaseSelected: [],
    countries: [],
    monthsArr: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    assetsList: [],
    redirect: false,
    states: [],
    oldInvoiceData: [],
    invoiceOtherData: [],
    financialYearOne: "",
    financialYearTwo: "",
    isOpen: false,
    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",
    tableTOShow: "",
    tableHeadingText: "",
    leaseList: [],
    formResponseData: [],
    formResponseData1: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    showUploadDocument: false,
    fileName: "",
    documentType: "",
    uploadedDocuments: [],
    currentDocument: "",
    submitFormData: {},
    initialValues: {
      leaseDocumentType: "",
      leaseDocumentUrl: "",
      leaseUploadDocumentDate: "",
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      brandCatId: "",
      brandName: [],
      leaseId: [],
      chargeTypeSelected: "",
      chargeType: "",
      financialYear: "",
      chargeType: "",
      financialYearOne: "",
      financialYearTwo: "",
    },
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  handleUpload() {
    this.uploader.uploadFile();
    const index = this.state.documentNames.indexOf(
      this.state.initialValues.leaseDocumentType
    );
    if (index > -1) {
      this.state.documentNames.splice(index, 1);
    }
    this.state.showUploadDocument = false;
    this.setState({});
  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input, { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  onUploadFinish = (e) => {
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/sales-input/update-lease-invoice`,
      data: this.state.submitFormData,
    }).then(function (response) {
      if (!response.data.success) {
        // alert("Something went wrong!");
        this.setState({
          popupalertMessage: true,
          popupMessageContent: 'Something went wrong!',
        });
      } else {
        // alert("Data Saved Successfully");
        // self.setState({
        //   formResponseData: [],
        //   oldInvoiceData: [],
        //   invoiceOtherData: [],
        //   totalInvoiceAmount: 0,
        // });
        // self.setState({ redirect: true });
        self.setState({
          messsagePopup: true,
        });
      }
    });
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input, { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (this.state.initialValues.brandId.length == 0 || this.state.initialValues.brandId == "") {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type
      this.state.initialValues.leaseId = [];
      this.state.leaseSelected = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.leaseId.push(newValue[i].value);
        this.state.selectedValue.push(newValue[i].value);
        this.state.leaseSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
      //   fetch(
      //     `${apiUrl.apiUrl.url}/lease-view/get-lease-financial-years?leaseId=` +
      //     this.state.initialValues.leaseId
      //   )
      //     .then((response) => {
      //       return response.json();
      //     })
      //     .then((data) => {
      //       this.setState({
      //         financialYear: data.fianancialYears,
      //       });
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value, { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ['0'];
          this.state.brandSelected.push({ "value": 0, 'label': 'All' });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }


          console.log(this.state.initialValues.brandId, "this.state.initialValues.brandId")
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {
      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value, { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {
      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByBrand();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_charge_type") {
      //change_lease_month
      //this.state.initialValues.chargeType = newValue.value;
      //this.state.initialValues.dataUOMName = newValue.label;

      console.log(this.state.initialValues, "initial valuyes");
      this.state.initialValues.chargeTypeSelected = newValue.value;
      this.state.initialValues.chargeType = newValue.value;
      //this.state.leaseSelected= [];
      // for (let i = 0; i < newValue.length; i++) {
      //   this.state.initialValues.chargeTypeSelected.push(newValue[i].value);
      //   //this.state.selectedValue.push(newValue[i].value);
      //   //this.state.leaseSelected.push({  'value' : newValue[i].value, 'label': newValue[i].label });
      // }
    } else if (actionMeta == "change_financial_yearone") {
      //change_lease_month
      this.state.initialValues.financialYearIdOne = newValue.value;
      this.state.initialValues.financialYearOne = newValue.label;
    } else if (actionMeta == "change_financial_yeartwo") {
      //change_lease_month
      this.state.initialValues.financialYearIdTwo = newValue.value;
      this.state.initialValues.financialYearTwo = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };


  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId + "&brandCategory=" + this.state.initialValues.brandCatId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

  }


  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };
  redirectAfterSave = () => {
    this.setState({
      formResponseData: [],
      oldInvoiceData: [],
      invoiceOtherData: [],
      totalInvoiceAmount: 0,
      messsagePopup: false,
    });
    this.setState({ redirect: true });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/invoice-validation" />;
    }
    return (
      <div className="masterContainer">
        <div className="parentContainer">
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <TopHeader />
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Home</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Invoice Validation</a>
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="padding_left_class"> */}
        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.leaseSelected = [];
            this.state.initialValues.chargeTypeSelected = "";
            this.state.chargeTypeSelected = "";
            this.state.financialYearOne = "";
            this.state.financialYearTwo = "";

            var counter = this.state.counter + 1;
            this.setState({
              formResponseData: [],
              oldInvoiceData: [],
              invoiceOtherData: [],
              tableTOShow: "",
              tableHeadingText: ""
            });



            this.setState({
              currentDocument: "",
            });

            this.setState({
              totalInvoiceAmount: "",
            });
            this.setState({ fileName: "" });
            this.setState({ counter: counter });

            this.setState({});
          }}
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;

            var counter = this.state.counter + 1;
            console.log(counter, "counter", form_config);

            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];
            var headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            fetch(
              `${apiUrl.apiUrl.url}/sales-input/fetch-invoice-details?` + prm,
              { headers }
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                //this.setState({  });

                var tableHeading = "";
                if ("Marketing Fund Tax" == this.state.initialValues.chargeTypeSelected) {
                  tableHeading = "MF";
                } else if ("Property Tax" == this.state.initialValues.chargeTypeSelected) {
                  tableHeading = "P TAX";
                } else if ("Parking 2W" == this.state.initialValues.chargeTypeSelected || "Parking 4W" == this.state.initialValues.chargeTypeSelected || "Parking Other" == this.state.initialValues.chargeTypeSelected) {
                  tableHeading = "Utility";
                } else if ("Storage" == this.state.initialValues.chargeTypeSelected) {
                  tableHeading = "Charge";
                }




                tableCounter = 0;
                this.setState({
                  formResponseData: data.data,
                  oldInvoiceData: data.oldInvoiceData,
                  invoiceOtherData: data.otherDetails,
                  tableTOShow: this.state.initialValues.chargeTypeSelected,
                  tableHeadingText: tableHeading
                });



                this.setState({
                  currentDocument: data.otherDetails.document_url,
                });

                this.setState({
                  totalInvoiceAmount: data.otherDetails.total_amt.invoiceAmount,
                });
                this.setState({ fileName: data.otherDetails.fileName });
                this.setState({ counter: counter });
                this.setState({
                  exportUrl:
                    `${apiUrl.apiUrl.url}/sales-input/fetch-revenue-details?export=true&` +
                    prm,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            resetForm,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      <div className="newGridSectionInner">
                        <label>Country</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="countryId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeCountry(e, "changecountry");
                            }}
                            value={{
                              label: this.state.initialValues.countryName,
                              value: this.state.initialValues.countryId,
                            }}
                            options={this.state.countries.map((item) => ({
                              label: item.country_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="countryId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>State</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={{
                              label: this.state.initialValues.state_name,
                              value: this.state.initialValues.state_id,
                            }}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="stateId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Brand Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="brandId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_brand");
                            }}
                            value={this.state.brandSelected}
                            options={this.state.brandList.map((item) => ({
                              label: item.brand_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="brandId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>District</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="districtId"
                            onChange={(e) => {
                              this.valueChange(e, "change_district");
                            }}
                            value={{
                              label: this.state.initialValues.districtName,
                              value: this.state.initialValues.districtId,
                            }}
                            options={this.state.districtList.map((item) => ({
                              label: item.district_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="districtId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Lease Number<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_number");
                            }}
                            value={this.state.leaseSelected}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="leaseId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>City</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="cityId"
                            onChange={(e) => {
                              this.valueChange(e, "change_city");
                            }}
                            value={{
                              label: this.state.initialValues.cityName,
                              value: this.state.initialValues.cityId,
                            }}
                            options={this.state.cityList.map((item) => ({
                              label: item.city_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="cityId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Charge Type<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valueChange(e, "change_charge_type");
                            }}
                            value={this.state.chargeTypeSelected}
                            name="chargeType"
                            options={[
                              "CAM",
                              "RENT",
                              "Property Tax",
                              "Marketing Fund Tax",
                              "Parking 2W",
                              "Parking 4W",
                              "Parking Other",
                              "Storage",
                              "Signage",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          <ErrorMessage
                            name="chargeType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Month<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) =>
                              this.setState({ financialYearOne: date })
                            }
                            className="w-100"
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />
                          <ErrorMessage
                            name="financialYearOne"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" d1isabled={isSubmitting} className="add_button">
                        <FontAwesomeIcon icon={faEye} /> Show
                      </button>
                      <button
                        type="reset"
                        onClick={(e) => {
                          resetForm();
                        }}
                        className="reset_button"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )
          }
        </Formik>
        {/* </div> */}
        < PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>

        <Formik
          initialValues={this.state.oldInvoiceData}
          enableReinitialize
          onChange={({ nextValues }) => {
            console.log(nextValues, "asdasdasd");
          }}
          onReset={(values, actions) => {
            this.setState({
              //formResponseData: data,
              formResponseData: this.state.formResponseData,
            });
          }}
          onSubmit={(values, actions) => {
            var self = this;

            values["leaseId"] = this.state.invoiceOtherData.leaseId;
            values["month"] = this.state.invoiceOtherData.date;

            if (
              this.state.totalInvoiceAmount !=
              this.state.invoiceOtherData.total_amt.net_charge_amount
            ) {
              // alert("please settle invoice amount");
              this.setState({
                popupalertMessage: true,
                popupMessageContent: 'please settle invoice amount',
              });
              return false;
            } else {
              this.uploader.uploadFile();
              values.filename =
                fileUploadPath() +
                this.state.invoiceOtherData.leaseId +
                "/" +
                this.state.fileName;
              values.chargeTypeSelected =
                this.state.initialValues.chargeTypeSelected;
              this.setState({ submitFormData: values });

              this.state.brandSelected = [];
              this.state.leaseSelected = [];
              this.state.securityDepositIds = [];

              for (const [key, value] of Object.entries(
                this.state.initialValues
              )) {
                this.state.initialValues[key] = "";
              }
              this.setState({});
            }
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            handleReset,

            isSubmitting,
          }) => (
            <Form autoComplete="off" >
              <div className="container-fluid cam pt-5">
                <div className="row">
                  <div className="col"></div>
                  <div className="tableContainer">
                    {this.state.tableTOShow == "RENT" &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Period</th>
                            <th scope="col">Month</th>
                            <th scope="col">Charge Type</th>
                            <th scope="col">Charge Logic</th>
                            <th scope="col">MG Rate</th>
                            <th scope="col">MG Amount</th>
                            <th scope="col">Net Sales</th>
                            <th scope="col">RS %</th>
                            <th scope="col">RS Amount</th>
                            <th scope="col">Fitout Rent Amount</th>
                            <th scope="col">CAM Amount</th>
                            <th scope="col">Net Charge Amount</th>
                            <th scope="col">Invoice Amount</th>
                            <th scope="col">Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.period}</td>
                                    <td>{anObjectMapped.month}</td>
                                    <td>{anObjectMapped.typeOfData}</td>
                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{anObjectMapped.mg_amount}</td>
                                    <td>{anObjectMapped.net_sales}</td>
                                    <td>{anObjectMapped.revenueShare}</td>
                                    <td>{anObjectMapped.revenue_amt}</td>
                                    <td>{anObjectMapped.fitoutRate}</td>
                                    <td>{anObjectMapped.cam_amt}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>
                                      <Field
                                        type="text"
                                        name={"amount." + anObjectMapped.type}
                                        onBlur={(e) => {
                                          this.handleCalculation(
                                            e,
                                            index,
                                            values
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{anObjectMapped.variance}</td>
                                  </tr>
                                );
                              }
                            )}
                          {this.state.formResponseData.length > 0 && (
                            <tr>
                              <td>Total</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_rate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_amount}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.net_sales}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenueShare
                                }
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenue_amt
                                }
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.fitoutRate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.cam_amt}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .net_charge_amount
                                }
                              </td>
                              <td>{this.state.totalInvoiceAmount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }
                    {(this.state.tableTOShow == "CAM") &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Period</th>
                            <th scope="col">Month</th>
                            <th scope="col">Charge Type</th>
                            <th scope="col">Charge Logic</th>
                            <th scope="col">CAM Rate</th>
                            <th scope="col">CAM Amount</th>
                            <th scope="col">Net Sales</th>
                            <th scope="col">CAM RS %</th>
                            <th scope="col">CAM RS Amount</th>
                            <th scope="col">CAM % RENT</th>
                            <th scope="col">CAM % RENT Amount</th>
                            <th scope="col">Net Charge Amount</th>
                            <th scope="col">Invoice Amount</th>
                            <th scope="col">Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.period}</td>
                                    <td>{anObjectMapped.month}</td>
                                    <td>{anObjectMapped.typeOfData}</td>
                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{anObjectMapped.mg_amount}</td>
                                    <td>{anObjectMapped.net_sales}</td>
                                    <td>{anObjectMapped.revenueShare}</td>
                                    <td>{anObjectMapped.revenue_amt}</td>
                                    <td>{anObjectMapped.fitoutRate}</td>
                                    <td>{anObjectMapped.cam_amt}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>
                                      <Field
                                        type="text"
                                        name={"amount." + anObjectMapped.type}
                                        onBlur={(e) => {
                                          this.handleCalculation(
                                            e,
                                            index,
                                            values
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{anObjectMapped.variance}</td>
                                  </tr>
                                );
                              }
                            )}
                          {this.state.formResponseData.length > 0 && (
                            <tr>
                              <td>Total</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_rate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_amount}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.net_sales}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenueShare
                                }
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenue_amt
                                }
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.fitoutRate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.cam_amt}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .net_charge_amount
                                }
                              </td>
                              <td>{this.state.totalInvoiceAmount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }
                    {(this.state.tableTOShow == "Property Tax" || this.state.tableTOShow == "Marketing Fund Tax") &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Month</th>
                            <th scope="col">Charge Type</th>
                            <th scope="col">Charge Logic</th>
                            <th scope="col">{this.state.tableHeadingText} Rate</th>
                            <th scope="col">{this.state.tableHeadingText} Amount</th>
                            <th scope="col">Net Sales</th>
                            <th scope="col">{this.state.tableHeadingText} RS %</th>
                            <th scope="col">{this.state.tableHeadingText} RS Amount</th>
                            <th scope="col">{this.state.tableHeadingText} % RENT</th>
                            <th scope="col">{this.state.tableHeadingText} % RENT Amount</th>
                            <th scope="col">Net Charge Amount</th>
                            <th scope="col">Invoice Amount</th>
                            <th scope="col">Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.month}</td>
                                    <td>{anObjectMapped.typeOfData}</td>
                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{anObjectMapped.mg_amount}</td>
                                    <td>{anObjectMapped.net_sales}</td>
                                    <td>{anObjectMapped.revenueShare}</td>
                                    <td>{anObjectMapped.revenue_amt}</td>
                                    <td>{anObjectMapped.fitoutRate}</td>
                                    <td>{anObjectMapped.cam_amt}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>
                                      <Field
                                        type="text"
                                        name={"amount." + anObjectMapped.type}
                                        onBlur={(e) => {
                                          this.handleCalculation(
                                            e,
                                            index,
                                            values
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{anObjectMapped.variance}</td>
                                  </tr>
                                );
                              }
                            )}
                          {this.state.formResponseData.length > 0 && (
                            <tr>
                              <td>Total</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_rate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_amount}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.net_sales}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenueShare
                                }
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenue_amt
                                }
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.fitoutRate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.cam_amt}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .net_charge_amount
                                }
                              </td>
                              <td>{this.state.totalInvoiceAmount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }
                    {(this.state.tableTOShow == "Parking 2W" || this.state.tableTOShow == "Parking 4W" || this.state.tableTOShow == "Parking Other" || this.state.tableTOShow == "Storage" || this.state.tableTOShow == "Signage") &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Month</th>
                            <th scope="col">Charge Type</th>
                            <th scope="col">Charge Logic</th>
                            <th scope="col">{this.state.tableHeadingText} Rate</th>
                            <th scope="col">{this.state.tableHeadingText} Amount</th>
                            <th scope="col">Net Charge Amount</th>
                            <th scope="col">Invoice Amount</th>
                            <th scope="col">Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.month}</td>
                                    <td>{anObjectMapped.typeOfData}</td>
                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{anObjectMapped.mg_amount}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>
                                      <Field
                                        type="text"
                                        name={"amount." + anObjectMapped.type}
                                        onBlur={(e) => {
                                          this.handleCalculation(
                                            e,
                                            index,
                                            values
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{anObjectMapped.variance}</td>
                                  </tr>
                                );
                              }
                            )}
                          {this.state.formResponseData.length > 0 && (
                            <tr>
                              <td>Total</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_rate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_amount}
                              </td>

                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .net_charge_amount
                                }
                              </td>
                              <td>{this.state.totalInvoiceAmount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }
                    {(this.state.tableTOShow == "Utility") &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Month</th>
                            <th scope="col">Charge Type</th>
                            <th scope="col">Charge Logic</th>
                            <th scope="col">{this.state.tableHeadingText} Rate</th>
                            <th scope="col">{this.state.tableHeadingText} Amount</th>
                            <th scope="col">Net Charge Amount</th>
                            <th scope="col">Invoice Amount</th>
                            <th scope="col">Variance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.month}</td>
                                    <td>{anObjectMapped.typeOfData}</td>
                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{anObjectMapped.mg_amount}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>
                                      <Field
                                        type="text"
                                        name={"amount." + anObjectMapped.type}
                                        onBlur={(e) => {
                                          this.handleCalculation(
                                            e,
                                            index,
                                            values
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{anObjectMapped.variance}</td>
                                  </tr>
                                );
                              }
                            )}
                          {this.state.formResponseData.length > 0 && (
                            <tr>
                              <td>Total</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_rate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.mg_amount}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.net_sales}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenueShare
                                }
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .revenue_amt
                                }
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.fitoutRate}
                              </td>
                              <td>
                                {this.state.invoiceOtherData.total_amt.cam_amt}
                              </td>
                              <td>
                                {
                                  this.state.invoiceOtherData.total_amt
                                    .net_charge_amount
                                }
                              </td>
                              <td>{this.state.totalInvoiceAmount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }
                    {this.state.formResponseData.length > 0 && (
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer formSubmit">
                          <div>
                            <a
                              className="clauseNameLink"
                              onClick={(e) => {
                                e.preventDefault();
                                //this.state.currentDocument = this.state.oldInvoiceData.documents.document_url;
                                this.setState({});
                                this.openModal();
                              }}
                            >
                              {
                                this.state.oldInvoiceData.documents
                                  .document_name
                              }
                            </a>

                            <ReactS3Uploader
                              signingUrl={`/site/get-s3signed-url`}
                              signingUrlMethod="GET"
                              accept="pdf/*"
                              s3path={`${fileUploadPath()}${this.state.invoiceOtherData.leaseId}/`}
                              preprocess={this.onUploadStart}
                              onSignedUrl={this.onSignedUrl}
                              onProgress={this.onUploadProgress}
                              onError={this.onUploadError}
                              onFinish={this.onUploadFinish}
                              onSelect={console.log("calingg")}
                              // signingUrlHeaders={{ additional: headers }}
                              // signingUrlQueryParams={{
                              //   additional: query - params,
                              // }}
                              signingUrlWithCredentials={false}
                              uploadRequestHeaders={
                                {
                                  //"x-amz-acl": "public-read",
                                }
                              }
                              contentDisposition="attachment"
                              scrubFilename={() => this.state.fileName}
                              server={`${apiUrl.apiUrl.url}`}
                              inputRef={(cmp) => (this.uploadInput = cmp)}
                              autoUpload={false}
                              ref={(uploader) => {
                                this.uploader = uploader;
                              }}
                            />
                            <button type="submit">
                              Save
                            </button>
                            <button type="reset">
                              <FontAwesomeIcon /> Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <Modal
                    show={this.state.isOpen}
                    onHide={this.closeModal}
                    size="lg"
                    className="documentModal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <div className="container modalBreadCrumbs">
                          <div className="row">
                            <div className="col-lg-12">
                              <ul>
                                <li>Document</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="container">
                        <div className="row">
                          <ViewLeasePdfReader
                            url={this.state.currentDocument}
                            pageNumber="1"
                          />
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div >
    );
  }
}

export default withRouter(InvoiceValidation);
